import { render } from "./Gastouder.vue?vue&type=template&id=f41b897e"
import script from "./Gastouder.vue?vue&type=script&lang=js"
export * from "./Gastouder.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__